<template>
  <v-menu
    v-model="menu"
    :close-on-content-click="false"
    transition="scale-transition"
    offset-y
    offset-overflow
    min-width="290px"
  >
    <template v-slot:activator="{ on, attrs }">
      <v-text-field
        ref="dateRef"
        v-model="textDate"
        prepend-icon="mdi-calendar-month"
        :rules="rules"
        maxlength="10"
        :disabled="disabled"
        :readonly="readonly"
        :clearable="!required"
        :hint="showHint"
        :persistentHint="showPersistentHint"
        @click:clear="dateClear"
        @input="inputChange"
        v-bind="attrs"
        v-on="on"
      >
        <template v-if="!hideLabel" #label>
          <span v-if="startRequired && required && !hiddenRequiredIcon" class="error--text">* </span>
          <span v-if="startRequired && onlyShowRequiredNotCheck" class="error--text">* </span>
          <span>{{ label }}</span>
          <span v-if="!startRequired && required && !hiddenRequiredIcon" class="error--text"> *</span>
          <span v-if="!startRequired && onlyShowRequiredNotCheck" class="error--text"> *</span>
        </template>
      </v-text-field>
    </template>
    <v-date-picker
      ref="datePicker"
      :year-format="birthdayMode ? formatYear : null"
      :max="max"
      @change="dateChange"
      v-model="pickDate"
    >
    </v-date-picker>
  </v-menu>
</template>

<script>
export default {
  name: "VDate.vue",
  data: () => ({
    menu: false,
    textDate: "",
    pickDate: "",
    showPersistentHint: false,
    showHint: "",
    fromToCheckRules: null
  }),
  model: {
    event: "selectedDate",
    prop: "actionDate"
  },
  props: {
    label: {
      type: String
    },
    required: {
      type: Boolean,
      default: false
    },
    hideLabel: {
      type: Boolean,
      default: false
    },
    actionDate: {
      type: String
    },
    elderly: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    hint: {
      type: String,
      default: undefined
    },
    max: {
      type: String,
      default: undefined
    },
    birthdayMode: {
      type: Boolean,
      default: false
    },
    readonly: {
      type: Boolean,
      default: false
    },
    hiddenRequiredIcon: {
      type: Boolean,
      default: false
    },
    onlyShowRequiredNotCheck: {
      type: Boolean,
      default: false
    },
    persistentHint: {
      type: Boolean,
      default: false
    },
    fromToCheck: {},
    startRequired: {
      type: Boolean,
      default: false
    }
  },
  watch: {
    actionDate: {
      handler() {
        this.textDate = this.actionDate;
        if (this.birthdayMode) {
          this.showPersistentHint = true;
          this.showHint = this.formatJapaneseDate(this.textDate);
        }
      }
    },
    menu(val) {
      if (this.birthdayMode) {
        val && this.$nextTick(() => (this.$refs.datePicker.internalActivePicker = "YEAR"));
      }
      if (val) {
        if (this.$refs.dateRef.validate()) {
          this.pickDate = this.textDate;
        } else {
          this.pickDate = new Date().format("yyyy-MM-dd");
        }
        if (!this.textDate) {
          this.pickDate = new Date().format("yyyy-MM-dd");
        }
        if (this.birthdayMode) {
          this.showPersistentHint = true;
          this.showHint = this.formatJapaneseDate(this.textDate);
        }
      }
    },
    fromToCheck: {
      handler() {
        this.fromToCheckRules = this.fromToCheck;
        this.$refs.dateRef.validate(true);
      }
    },
    label() {
      this.$nextTick(() => {
        this.$refs.dateRef?.validate(true);
      });
    }
  },
  computed: {
    rules() {
      let result = [];
      if (!this.required) {
        result = [this.$getValidate("dateFormat", this.label), this.$getValidate("maxlength", this.label, 10)];
      } else {
        result = [
          this.$getValidate("required", this.label),
          this.$getValidate("dateFormat", this.label),
          this.$getValidate("maxlength", this.label, 10)
        ];
      }
      if (this.fromToCheckRules) {
        result.push(this.fromToCheckRules);
      }
      return result;
    }
  },
  methods: {
    dateChange(date) {
      this.textData = date;
      this.menu = false;
      this.$emit("selectedDate", date);
      this.$emit("change");
    },
    dateClear() {
      this.$emit("selectedDate", "");
      this.$emit("change");
    },
    inputChange(value) {
      this.$emit("selectedDate", value);
      this.$emit("change");
    },
    getEraNames(year) {
      const eras = this.$dateUtils.getEraList();

      const startDate = new Date(`${year}-01-01`);
      const endDate = new Date(`${year}-12-31`);

      const matchingEras = [];

      for (let i = 0; i < eras.length; i++) {
        const eraStart = new Date(eras[i].startDate);
        const nextEraStart = i > 0 ? new Date(eras[i - 1].startDate) : null;

        if (eraStart <= endDate && (!nextEraStart || nextEraStart > startDate)) {
          const eraYear = year - eraStart.getFullYear() + 1;
          matchingEras.push(`${eras[i].name}${eraYear === 1 ? "元" : eraYear}年`);
        }
      }
      return matchingEras;
    },
    formatYear(year) {
      const eras = this.getEraNames(year);
      if (eras.length === 0) return `${year}年`;
      if (eras.length === 1) return `${year}年（${eras[0]}）`;
      return `${year}年（${eras.join("／")}）`;
    },
    formatJapaneseDate(dateStr) {
      const eras = this.$dateUtils.getEraList();
      if (!/^\d{4}-\d{2}-\d{2}$/.test(dateStr)) return "";

      const date = new Date(dateStr);
      const year = date.getFullYear();
      const month = date.getMonth() + 1;
      const day = date.getDate();

      for (const era of eras) {
        const startDate = new Date(era.startDate);
        if (date >= startDate) {
          const eraYear = year - startDate.getFullYear() + 1;
          const eraYearStr = eraYear === 1 ? "元" : eraYear;
          return `${era.name}${eraYearStr}年${month}月${day}日`;
        }
      }
      return dateStr;
    },
    reset() {
      this.$refs.dateRef.reset();
    }
  },
  created() {
    if (this.actionDate) {
      this.textDate = this.$utils.dateStrFormat(this.actionDate, "-");
      this.pickDate = this.$utils.dateStrFormat(this.actionDate, "-");
      this.fromToCheckRules = this.fromToCheck;
      if (this.birthdayMode) {
        this.showPersistentHint = true;
        this.showHint = this.formatJapaneseDate(this.textDate);
      }
    }
    if (this.persistentHint) {
      this.showPersistentHint = this.persistentHint;
    }
    if (this.hint) {
      this.showHint = this.hint;
    }
  }
};
</script>

<style scoped></style>
